export default __webpack_public_path__ + "static/media/ifrs_thumbnail.372be45d.jpeg";